<template>
<div class="container " style="padding-top: 100px;">
    <div class="columns is-centered">
        <div class="column is-5-tablet is-4-desktop is-3-widescreen">
            <form action="" class="box">
                <b-field label="Email">
                    <b-input type="text" v-model="username" placeholder="Email" required @keyup.enter.native="login()" ref="username"></b-input>
                </b-field>
                <b-field label="Password">
                    <b-input type="password" v-model="password" password-reveal placeholder="Password" required @keyup.enter.native="login()"></b-input>
                </b-field>
                <b-button class="button is-light" expanded @click.prevent="login()">Login</b-button>
            </form>
        </div>
    </div>
</div>
</template>
<script>
import { mapGetters } from "vuex"
import { UsuarioService } from "../rest"
import { Data, Storage } from "../util"
import Toast from "../util/toast"
export default {
    name: "Login",
    data() {
        return {
            username: "",
            password: "",
        }
    },
    computed: {
        ...mapGetters("AppStore", ["url"]),
    },
    methods: {
        login() {
            if (this.username && this.password) {
                if (!this.username.includes("@")) {
                    this.username = this.username.concat("@epcmexperts.com")
                }
                UsuarioService.login(this.username, this.password).then(
                    response => {
                        if (response) {
                            // para cargar datos que puede ser utilizados en los dropdowns
                            Data.loadLists()
                            // redirigiendo a la ruta pendiente de login si la hibiera
                            if (Storage.getObject("to") != null) {
                                const to = Storage.getObject("to")
                                Storage.remove("to")
                                this.$router.push(to.path)
                            }
                            else {
                                this.$router.push("/home")
                            }
                        } else {
                            Toast.error("Credenciales incorrectas")
                        }
                    },
                    error => {
                        Toast.error("Credenciales incorrectas")
                        console.error(`error: `, error)
                    }
                )
            }
        }
    },
    mounted() {
        this.$refs.username.focus()
        if (UsuarioService.getUsuario()) {
            // para borrar todo dato del usuario que ha iniciado sesion anteriormente
            UsuarioService.remove()
        }
    }
}
</script>
<style scoped></style>
